import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { ApiError } from '@/lib/api';
import { NotificationProvider } from '@/lib/notifications';
import { router } from '@/router';
import '@fontsource/ibm-plex-sans/latin-300.css';
import '@fontsource/ibm-plex-sans/latin-400.css';
import '@fontsource/ibm-plex-sans/latin-600.css';
import '@fontsource/ibm-plex-mono/latin-400.css';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // The archive updates on a crawl cadence measured in hours, not seconds. Refetching
      // on every window focus would spend requests to redraw the same screen.
      staleTime: 60_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) =>
        // Signed out, forbidden, or absent: retrying cannot change any of those answers.
        error instanceof ApiError && [401, 403, 404].includes(error.status) ? false : failureCount < 2,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <NotificationProvider>
        <RouterProvider router={router} />
      </NotificationProvider>
    </QueryClientProvider>
  </StrictMode>,
);
